<script>
  import ValidationMessage from '../../../components/form/ValidationMessage.vue'
  import BackButton from '../../../components/general/BackButton.vue'

  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import DataService from '../../../services/dataService'

  import helperMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'

  import {required} from 'vuelidate/lib/validators'
  import {orderBy, debounce} from 'lodash'

  export default {
    mixins: [helperMixin],
    components: {ValidationMessage, BackButton},
    data () {
      return {
        isLoadingData: true,
        form: {},
        activeTab: 'general-data',
        modalEditInstitutionVisible: false,
        modalEditLiteracyVisible: false,
        modalEditKnowledgeAreaVisible: false,
        modalLimesurvey: false,
        linkLimesurvey: '',
        isSearchingInstitution: false,
        modalInvoice: false,
        invoiceUrl: '',
        certificate: {
          modal: false,
          path: '',
          path_download: ''
        },
        institution_unit_id: '',
        literacy_id: '',
        knowledge_area: {
          knowledge_area: [],
          knowledge_area_1_id: [],
          knowledge_area_2_id: [],
          knowledge_area_3_id: [],
          knowledge_area_4_id: []
        },
        dependencies: {
          literacies: [],
          institutions: [],
          modalities: [],
          activities: [],
          knowledge_areas: [],
          knowledge_areas_level_1: [],
          knowledge_areas_level_2: [],
          knowledge_areas_level_3: [],
          knowledge_areas_level_4: [],
          minicursos: []
        },
        modalOnlinePaymentLinkVisible: false,
        onlinePaymentOrder: '',
        onlinePaymentUrl: '',
        onlinePaymentValue: '',
        showRegenerate: false,
        regenerateTypingText: ''
      }
    },
    validations: {
      literacy_id: {required},
      institution_unit_id: {required}
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      const tab = this.$route.params.tab || 'general-data'
      this.loadRegistration(id, tab)
      this.loadLimesurvey(id)
      window.addEventListener('keypress', this.checkRegenerateTyping)
    },
    beforeDestroy () {
      window.removeEventListener('keyup', this.checkRegenerateTyping)
    },
    computed: {
      invoices: function () {
        return [].concat.apply([], this.form.modalities.map(item => item.invoices))
      },
      allInvoiceSettled: function () {
        return this.invoices.every(item => item.status.key === 'pago')
      },
      registrationNotCharged: function () {
        return this.form.status.key === 'sem_custo'
      },
      registrationCanceled: function () {
        return this.form.status.key === 'cancelado'
      },
      certificateAvailable () {
        return !this.registrationCanceled && this.invoiceSettled
      },
      hasAppraiserModality () {
        return this.form.modalities.some(item => item.event_modality.modality.key === 'avaliador')
      },
      hasParticipantMainEventModality () {
        return this.form.modalities.some(item => item.event_modality.modality.key === 'evento_principal')
      },
      hasSupportCommitteeModality () {
        return this.form.modalities.some(item => item.event_modality.modality.key === 'comissao_apoio')
      }
    },
    methods: {
      checkRegenerateTyping: debounce(function (event) {
        this.regenerateTypingText += event.key.toLowerCase()
        if (this.regenerateTypingText.indexOf('regenerate-up') !== -1) {
          this.showRegenerate = true
          this.regenerateTypingText = ''
        }
        if (this.regenerateTypingText.indexOf('regenerate-down') !== -1) {
          this.showRegenerate = false
          this.regenerateTypingText = ''
        }
      }, 50),
      getDependencies () {
        DataService.get([
          {domain: 'literacy'}
        ]).then((result) => {
          this.dependencies = {...this.dependencies, ...result}
        })
      },
      getMinicursos (id) {
        if (id) {
          restfulService.get('event', 'minicursos', id)
            .then(response => {
              response.forEach(item => {
                item.registration = this.form.modalities.find(eventModality => eventModality.event_modality.event_id === item.id)
              })
              this.dependencies.minicursos = [...response]
            })
            .catch((err) => {
              console.log(err)
            })
        }
      },
      loadLimesurvey (id) {
        if (id) {
          restfulService.get('registration', 'limesurvey', id)
            .then(response => {
              if (response.link && !response.answered) {
                this.modalLimesurvey = true
                this.linkLimesurvey = response.link
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          bus.$emit('hide-loader')
        }
      },
      loadRegistration (id, tab) {
        if (id) {
          restfulService.get('registration', 'public', id)
            .then(response => {
              response.modalities = orderBy(response.modalities, ['event_modality.modality.name'], ['asc'])
              this.form = response
              this.form.modalities.forEach(item => {
                if (item.event_modality.modality.key === 'avaliador') {
                  this.$set(item, 'avaliacao_web', item.evaluation_types.some(evaluationType => evaluationType.evaluation_type.key === 'avaliacao_web'))
                  this.$set(item, 'avaliacao_inloco', item.evaluation_types.some(evaluationType => evaluationType.evaluation_type.key === 'avaliacao_inloco'))
                }
              })
              this.dependencies.institutions.push(response.institution)
              this.institution_unit_id = response.institution_unit_id
              this.literacy_id = response.literacy_id
              this.getMinicursos(response.event_main_id)

              this.knowledge_area.knowledge_area = [...response.knowledge_areas.map(item => item.knowledge_area_id)]
              this.knowledge_area.knowledge_area_1_id = [...response.knowledge_areas.filter(item => item.knowledge_area.level === 1).map(item => item.knowledge_area_id)]
              this.knowledge_area.knowledge_area_2_id = [...response.knowledge_areas.filter(item => item.knowledge_area.level === 2).map(item => item.knowledge_area_id)]
              this.knowledge_area.knowledge_area_3_id = [...response.knowledge_areas.filter(item => item.knowledge_area.level === 3).map(item => item.knowledge_area_id)]
              this.knowledge_area.knowledge_area_4_id = [...response.knowledge_areas.filter(item => item.knowledge_area.level === 4).map(item => item.knowledge_area_id)]

              // Busca as áreas de conhecimento
              this.getKnowledgeAreas(null, 1).then(() => {
                if (this.knowledge_area.knowledge_area.length === 0) {
                  this.resetKnowledgeAreas()
                } else {
                  if (this.knowledge_area.knowledge_area_1_id.length > 0) {
                    this.getKnowledgeAreas(this.knowledge_area.knowledge_area_1_id, 2).then(() => {
                      if (this.knowledge_area.knowledge_area_2_id.length > 0) {
                        this.getKnowledgeAreas(this.knowledge_area.knowledge_area_2_id, 3).then(() => {
                          if (this.knowledge_area.knowledge_area_3_id.length > 0) {
                            this.getKnowledgeAreas(this.knowledge_area.knowledge_area_3_id, 4)
                          }
                        })
                      }
                    })
                  }
                  setTimeout(() => {
                    this.hasAppraisers = true
                  }, 600)
                }
              })

              this.activeTab = tab
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
            .catch((err) => {
              console.log(err)
              this.isLoadingData = false
              bus.$emit('hide-loader')
            })
        } else {
          bus.$emit('hide-loader')
        }
      },
      invoiceSettled (registrationInvoice) {
        return registrationInvoice.status.key === 'pago'
      },
      invoiceOverdue (registrationInvoice) {
        return registrationInvoice.invoice && registrationInvoice.invoice.due_date < this.dateFormat(this.momentNow(), 'Y-m-d')
      },
      invoiceAmountLeft (registrationInvoice) {
        return registrationInvoice.invoice ? parseFloat(registrationInvoice.invoice.amount_left) : 0
      },
      onSearchInstitution (query) {
        if (query !== '') {
          this.isSearchingInstitution = true
          let data = {query}
          restfulService.post('institution', 'search', null, data)
            .then((response) => {
              this.dependencies.institutions.splice(0)
              this.dependencies.institutions = [...this.dependencies.institutions, ...response]
              this.isSearchingInstitution = false
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      changeTab (value) {
        const id = this.$route.params.id || null
        this.$router.push({name: 'registration.show', params: {id: id, tab: value.name}})
        bus.$emit('hide-loader')
      },
      generateCertificate (item, paperId, regenerate) {
        bus.$emit('show-loader')
        paperId = paperId || null
        regenerate = regenerate || null
        let data = {}
        if (paperId) {
          data.paper_id = paperId
        }
        if (regenerate) {
          data.regenerate = regenerate
        }
        restfulService.post('certificate', 'generate', item.event_modality_registration_id, data)
          .then((response) => {
            this.certificate.path = response.certificate_url + '?ts=' + new Date().getTime()
            this.certificate.path_download = response.certificate_url_download + '?ts=' + new Date().getTime()
            this.certificate.modal = true
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      showInvoice (registrationInvoice) {
        this.invoiceUrl = registrationInvoice.invoice_url
        this.modalInvoice = true
      },
      regenerateInvoice (registrationInvoice) {
        bus.$emit('show-loader')
        this.isLoadingData = true
        restfulService.post('registration', 'regenerate-invoice', this.form.id, registrationInvoice)
          .then(response => {
            bus.$emit('hide-loader')
            notifyService.success({hideLoader: true, message: 'Segunda via do boleto gerada com sucesso.'})
            registrationInvoice.invoice.due_date = response.due_date
            registrationInvoice.invoice.amount = response.amount
            this.isLoadingData = false
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.isLoadingData = false
            console.log(e)
          })
      },
      modalityAvailable (item) {
        return true
        // return (item.event_modality.modality.key === 'evento_principal' || (item.event_modality.modality.key === 'participante' && item.papers.length > 0))
      },
      onHandleModalEditInstitution () {
        this.modalEditInstitutionVisible = !this.modalEditInstitutionVisible
        if (!this.modalEditInstitutionVisible) {
          this.institution_unit_id = ''
          this.$v.institution_unit_id.$reset()
        }
      },
      onHandleModalEditLiteracy () {
        this.modalEditLiteracyVisible = !this.modalEditLiteracyVisible
        if (!this.modalEditLiteracyVisible) {
          this.literacy_id = ''
          this.$v.literacy_id.$reset()
        }
      },
      editInstitution () {
        this.$swal({
          title: 'Deseja realmente editar sua instituição?',
          text: 'O valor da sua inscrição pode sofrer alterações',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            this.onHandleModalEditInstitution()
          })
      },
      editLiteracy () {
        this.$swal({
          title: 'Deseja realmente editar sua escolaridade?',
          text: 'O valor da sua inscrição pode sofrer alterações',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            this.onHandleModalEditLiteracy()
          })
      },
      onSaveInstitution () {
        bus.$emit('show-loader')
        let data = {
          registration_id: this.form.id,
          institution_unit_id: this.institution_unit_id
        }
        restfulService.put('registration', 'institution', this.form.id, data)
          .then(() => {
            const institution = this.dependencies.institutions.find(item => item.id === this.institution_unit_id)
            this.form.institution = institution
            this.onHandleModalEditInstitution()
            notifyService.success({hideLoader: true, message: 'Instituição da inscrição atualizada.'})
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      onSaveLiteracy () {
        bus.$emit('show-loader')
        let data = {
          registration_id: this.form.id,
          literacy_id: this.literacy_id
        }
        restfulService.put('registration', 'literacy', this.form.id, data)
          .then(() => {
            const literacy = this.dependencies.literacies.find(item => item.id === this.literacy_id)
            this.form.literacy = literacy
            this.onHandleModalEditLiteracy()
            notifyService.success({hideLoader: true, message: 'Escolaridade da inscrição atualizada.'})
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      registrationNewEvent () {
        console.log('fdsfsdfsd')
      },
      onHandleModalEditKnowledgeArea () {
        this.modalEditKnowledgeAreaVisible = !this.modalEditKnowledgeAreaVisible
      },
      /**
       * Busca áreas de conhecimento na API
       * Cada level preenche uma lista de áreas de conhecimento diferente
       * 1: Grande Área, 2: Área, 3: Sub-área, 4: Especialidade
       *
       * @param knowledgeAreaId
       * @param level
       * @returns {Promise<any>}
       */
      getKnowledgeAreas (knowledgeAreaId, level) {
        return new Promise((resolve, reject) => {
          let searchData = {
            knowledge_area_id: null,
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          if (knowledgeAreaId && knowledgeAreaId.length > 0) {
            searchData.knowledge_area_id = {in: knowledgeAreaId}
          }
          restfulService.search('knowledge_area', null, searchData, null, null, 1, 500)
            .then((response) => {
              if (level === 1) {
                this.dependencies.knowledge_areas_level_1.splice(0)
                this.dependencies.knowledge_areas_level_1 = [...this.dependencies.knowledge_areas_level_1, ...response.data]
              } else if (level === 2) {
                this.dependencies.knowledge_areas_level_2.splice(0)
                this.dependencies.knowledge_areas_level_2 = [...this.dependencies.knowledge_areas_level_2, ...response.data]
              } else if (level === 3) {
                this.dependencies.knowledge_areas_level_3.splice(0)
                this.dependencies.knowledge_areas_level_3 = [...this.dependencies.knowledge_areas_level_3, ...response.data]
              } else if (level === 4) {
                this.dependencies.knowledge_areas_level_4.splice(0)
                this.dependencies.knowledge_areas_level_4 = [...this.dependencies.knowledge_areas_level_4, ...response.data]
              }
              resolve()
            })
            .catch(e => {
              reject(e)
            })
        })
      },
      /**
       * Reseta as informações das áreas de conhecimento
       */
      resetKnowledgeAreas () {
        this.knowledge_area.knowledge_area.splice(0)
        this.knowledge_area.knowledge_area_1_id.splice(0)
        this.knowledge_area.knowledge_area_2_id.splice(0)
        this.knowledge_area.knowledge_area_3_id.splice(0)
        this.knowledge_area.knowledge_area_4_id.splice(0)
      },
      /**
       * Evento: Disparado quando se selecionam novas áreas de conhecimento
       */
      changeKnowledgeArea (knowledgeAreaId, level) {
        if (level === 2) {
          this.knowledge_area.knowledge_area_2_id.splice(0)
          this.knowledge_area.knowledge_area_3_id.splice(0)
          this.knowledge_area.knowledge_area_4_id.splice(0)
        } else if (level === 3) {
          this.knowledge_area.knowledge_area_3_id.splice(0)
          this.knowledge_area.knowledge_area_4_id.splice(0)
        } else if (level === 4) {
          this.knowledge_area.knowledge_area_4_id.splice(0)
        }
        knowledgeAreaId.forEach(item => {
          if (!this.knowledge_area.knowledge_area.some(obj => obj === item)) {
            this.knowledge_area.knowledge_area.push(item)
          }
        })
        this.getKnowledgeAreas(knowledgeAreaId, level)
      },
      /**
       * Evento: Disparado quando uma área de conhecimento é removida da lista
       */
      removeKnowledgeArea (knowledgeAreaId) {
        this.knowledge_area.knowledge_area = this.knowledge_area.knowledge_area.filter(item => item !== knowledgeAreaId)
      },

      /**
       * Filtra as áreas de conhecimento selecionadas
       * @returns {Array}
       */
      getSelectedsKnowledgeAreas: function () {
        let knowledgeAreas = []
        if (this.knowledge_area.knowledge_area && this.knowledge_area.knowledge_area.length > 0) {
          this.knowledge_area.knowledge_area.forEach(item => {
            let knowledgeArea = []
            knowledgeArea = this.dependencies.knowledge_areas_level_1.filter(obj => obj.id === item)
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_2.filter(obj => obj.id === item)
            }
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_3.filter(obj => obj.id === item)
            }
            if (!knowledgeArea.length) {
              knowledgeArea = this.dependencies.knowledge_areas_level_4.filter(obj => obj.id === item)
            }
            if (knowledgeArea.length) {
              knowledgeAreas.push(knowledgeArea[0])
            }
          })
          return knowledgeAreas.sort((a, b) => a.full_name > b.full_name)
        }
        return knowledgeAreas
      },
      onSaveKnowledgeAreas () {
        let selectedKnowledgeAreas = this.getSelectedsKnowledgeAreas()
        let data = {}
        data.registration_id = this.form.id
        data.knowledge_areas = selectedKnowledgeAreas.map(item => item.id)
        restfulService.put('registration', 'knowledge-areas', data.registration_id, data)
          .then(() => {
            notifyService.success({hideLoader: true, message: 'Áreas de conhecimento atualizadas.'})
            this.loadRegistration(data.registration_id, 'events')
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      getMinicursoAmount (item) {
        if (item.modalities.length) {
          if (item.modalities[0].current_price && item.modalities[0].current_price.amount) {
            return item.modalities[0].current_price.amount
          }
        }
        return '0'
      },
      onMinicursoRegistration (item) {
        bus.$emit('show-loader')
        this.$swal({
          title: 'Confirmar inscrição no minicurso',
          text: '',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, confirmar!'
        })
          .then(() => {
            restfulService.post('registration', 'minicurso/' + item.id, this.form.id)
              .then(response => {
                item.registration = Object.assign({}, item.registration, response)
                notifyService.success({hideLoader: true, message: 'Inscrição no minicurso realizada.'})
                bus.$emit('hide-loader')
              })
              .catch(e => {
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      onCancelMinicursoRegistration (item) {
        bus.$emit('show-loader')
        this.$swal({
          title: 'Deseja realmente cancelar a sua inscrição?',
          text: 'Essa ação não pode ser revertida',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            restfulService.put('registration', 'minicurso/' + item.registration.id + '/cancel', this.form.id)
              .then(() => {
                item.registration = null
                notifyService.success({hideLoader: true, message: 'Inscrição no minicurso cancelada.'})
                bus.$emit('hide-loader')
              })
              .catch(e => {
                bus.$emit('hide-loader')
                console.log(e)
              })
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      changeEvaluationType ($event, evaluation, item) {
        let data = {
          evaluation: evaluation,
          value: item[evaluation]
        }
        restfulService.post('registration', 'appraiser/evaluation', item.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.$set(item, evaluation, !item[evaluation])
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      showPaymentLink (registrationInvoice) {
        bus.$emit('show-loader')
        restfulService.get('registration', this.form.id + '/get-payment-link/' + registrationInvoice.invoice_id)
          .then((response) => {
            if (!response.error) {
              this.modalOnlinePaymentLinkVisible = true
              this.onlinePaymentOrder = response.id
              this.onlinePaymentValue = response.valor
              this.onlinePaymentUrl = response.url_pagamento
              window.open(this.onlinePaymentUrl, '_blank')
              bus.$emit('hide-loader')
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.$swal({
              title: 'Erro',
              html: 'Erro ao gerar link de pagamento. Tente novamente mais tarde',
              type: 'error'
            })
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData" class="custom-list">

        <h2 class="flex-header">
            <span>Inscrição #{{form.id}} / {{form.main_event.title}}</span>
            <back-button/>
        </h2>
        <el-tabs v-model="activeTab" @tab-click="changeTab">
            <el-tab-pane name="general-data">
                <div slot="label" class="tab-slot">
                    <i class="fa fa-info"></i>
                    <span>Dados Gerais</span>
                </div>
                <el-alert title="Dados pessoais"
                          class="submission-tips"
                          type="warning"
                          :closable="false">
                    <ul>
                        <li>Para editar os seus dados pessoais acesse o <a href="https://sou.urcamp.edu.br"
                                                                           target="_blank" title="Clique aqui">Sou
                            URCAMP</a></li>
                    </ul>
                </el-alert>
                <table class="table-confirmation">
                    <tbody>
                    <tr>
                        <td width="50%">
                            <strong>Nome:</strong> {{form.person.pessoa.nome}} ({{form.person.ref_pessoa}})
                        </td>
                        <td width="50%">
                            <strong>CPF:</strong> {{form.person.pessoa.cpf}}
                        </td>
                    </tr>
                    <tr>
                        <td width="50%">
                            <strong>Data Nascimento:</strong> {{form.person.pessoa.dt_nascimento | dateEnToBr}}
                        </td>
                        <td width="50%">
                            <strong>RG:</strong> {{form.person.pessoa.rg_numero}}
                        </td>
                    </tr>
                    <tr>
                        <td width="50%">
                            <strong>Celular:</strong> {{form.person.pessoa.fone_celular}}
                        </td>
                        <td width="50%">
                            <strong>Email:</strong> {{form.person.pessoa.email}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <el-button title="Editar Instituição"
                                       type="primary"
                                       size="mini"
                                       v-if="false"
                                       @click="editInstitution"
                                       class="btn-edit-registration">
                                <i class="fa fa-edit"></i>
                            </el-button>
                            <strong>Instituição:</strong>
                            {{form.institution.name}}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <el-button title="Editar Escolaridade"
                                       type="primary"
                                       size="mini"
                                       v-if="false"
                                       @click="editLiteracy"
                                       class="btn-edit-registration">
                                <i class="fa fa-edit"></i>
                            </el-button>
                            <strong>Escolaridade:</strong>
                            {{form.literacy.name}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="events">
                <div slot="label" class="tab-slot">
                    <i class="fa fa-calendar"></i>
                    <span>Eventos</span>
                </div>
                <el-button type="success" @click="registrationNewEvent" v-if="false">
                    <i class="fa fa-plus"></i>
                    <span>Inscrição em outro evento</span>
                </el-button>
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th>Evento</th>
                        <th>Modalidade</th>
                        <th>Certificado</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in form.modalities"
                        v-if="modalityAvailable(item)">
                        <td>{{item.event_modality.event.title}}</td>
                        <td align="center">
                            <div>{{item.event_modality.modality.name}}</div>
                            <div v-if="item.event_modality.modality.key === 'avaliador'">
                                <el-row :gutter="15">
                                    <el-col :span="12">
                                        <strong>Web</strong>
                                        <el-switch v-model="item.avaliacao_web"
                                                   @change="changeEvaluationType($event, 'avaliacao_web', item)"
                                                   active-color="#13ce66"
                                                   inactive-color="#ff4949">
                                        </el-switch>
                                    </el-col>
                                    <el-col :span="12">
                                        <strong>InLoco</strong>
                                        <el-switch v-model="item.avaliacao_inloco"
                                                   @change="changeEvaluationType($event, 'avaliacao_inloco', item)"
                                                   active-color="#13ce66"
                                                   inactive-color="#ff4949">
                                        </el-switch>
                                    </el-col>
                                </el-row>
                            </div>
                        </td>
                        <td align="center">
                            <div v-if="item.certificates.length > 0">
                                <div class="certificates-buttons" v-for="certificate in item.certificates">
                                    <el-button size="mini"
                                               type="success"
                                               v-if="certificate.available && certificateAvailable"
                                               @click="generateCertificate(certificate, certificate.paper_id, (showRegenerate ? 'regenerate': null))">
                                        <i class="fa fa-download"></i>
                                        <span v-if="!showRegenerate">Baixar Certificado</span>
                                        <span v-if="showRegenerate">Regerar e Baixar Certificado</span>
                                        <span v-if="certificate.title"> - Submissão: #{{certificate.paper_id}}</span>
                                    </el-button>
                                    <div v-if="!certificate.available || !certificateAvailable">
                                        Aguardando data de liberação
                                        <span class="small" v-if="certificate.release_date"><br>
                                            Liberação em: <strong>{{certificate.release_date | dateTimeEnToBr}}</strong>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="certificate-not-available" v-else>Certificado não disponível</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation" v-if="hasAppraiserModality">
                    <thead>
                    <tr>
                        <th colspan="2">Áreas de Conhecimento para Avaliação</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <div v-for="item in form.knowledge_areas" v-if="form.knowledge_areas.length > 0">
                                {{item.knowledge_area.full_name}}
                            </div>
                            <div v-if="form.knowledge_areas.length === 0">Nenhuma área escolhida</div>
                        </td>
                        <td align="center">
                            <el-button size="small"
                                       type="primary"
                                       @click="onHandleModalEditKnowledgeArea">
                                <i class="fa fa-edit"></i>
                                <span>Selecionar Áreas</span>
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="payment">
                <div slot="label" class="tab-slot">
                    <i class="fa fa-money"></i>
                    <span class="tab-slot-text">Pagamento</span>
                    <span class="payment-bullet" :class="{'-not-settled' : !allInvoiceSettled}"></span>
                </div>
                <div class="responsive-table">
                    <table class="table-confirmation">
                        <thead v-if="(!registrationCanceled && !registrationNotCharged) || (registrationNotCharged && invoices.length > 0)">
                        <tr>
                            <th>Pagamento</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                            <th>Vencimento</th>
                        </tr>
                        </thead>
                        <tbody v-if="(!registrationCanceled && !registrationNotCharged) || (registrationNotCharged && invoices.length > 0)">
                        <tr v-for="(registrationInvoice, index) in invoices" class="invoice-info">
                            <td>
                                <el-button type="primary" @click="showInvoice(registrationInvoice)"
                                           v-if="!invoiceSettled(registrationInvoice) && !invoiceOverdue(registrationInvoice) && invoiceAmountLeft(registrationInvoice) > 0">
                                    <i class="fa fa-barcode"></i>
                                    <span>Boleto</span>
                                </el-button>
                                <el-button type="warning" @click="showPaymentLink(registrationInvoice)"
                                           v-if="!invoiceSettled(registrationInvoice) && !invoiceOverdue(registrationInvoice) && invoiceAmountLeft(registrationInvoice) > 0">
                                  <i class="fa fa-credit-card-alt"></i>
                                  <span>Pagamento On-line</span>
                                </el-button>
                                <el-button size="medium"
                                           type="warning"
                                           v-if="invoiceOverdue(registrationInvoice) && invoiceAmountLeft(registrationInvoice) > 0 && !invoiceSettled(registrationInvoice)"
                                           @click="regenerateInvoice(registrationInvoice, index)">
                                    <i class="fa fa-barcode"></i>
                                    <span>2ª Via</span>
                                </el-button>
                                <el-tag v-if="invoiceSettled(registrationInvoice)"
                                        type="success">
                                    Pago
                                </el-tag>
                            </td>
                            <td>{{registrationInvoice.invoice ? registrationInvoice.invoice.obs : 'Inscrição'}}</td>
                            <td><strong>R$ {{registrationInvoice.invoice.amount | currencyEnToBr}}</strong></td>
                            <td>
                                <div :class="{'invoice-info-settled': invoiceSettled(registrationInvoice)}">
                                    <strong>{{registrationInvoice.invoice.due_date | dateEnToBr}}</strong>
                                </div>
                                <div :class="{'invoice-info-settled': !invoiceSettled(registrationInvoice)}"
                                     v-if="invoiceSettled(registrationInvoice)">
                                    Pagamento em:
                                    <strong>{{registrationInvoice.invoice.pay_date | dateEnToBr}}</strong>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-if="registrationCanceled">
                        <tr>
                            <td colspan="2" class="invoice-info">
                                <el-tag class="payment-settled"
                                        type="danger">
                                    Inscrição Cancelada
                                </el-tag>
                            </td>
                        </tr>
                        </tbody>
                        <tbody v-if="registrationNotCharged && invoices.length === 0">
                        <tr>
                            <td colspan="2" class="invoice-info">
                                <el-tag class="payment-settled"
                                        type="warning">
                                    Inscrição Sem Custo
                                </el-tag>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane name="short-courses">
                <div slot="label" class="tab-slot">
                    <i class="fa fa-podcast"></i>
                    <span class="tab-slot-text">Minicursos</span>
                </div>
                <el-alert title="Informações Importantes"
                          class="submission-tips"
                          type="warning"
                          :closable="false">
                    <ul>
                        <li v-if="hasParticipantMainEventModality">Participantes inscritos no Congrega ganham 2
                            minicursos/oficinas de graça
                        </li>
                        <li>Programação e Descrição das Minicursos/oficinas: <a
                                href="https://urcamp.edu.br/pesquisa-e-extensao/congrega-2021/programacao-oficial-do-evento/oficinas"
                                target="_blank">Clique Aqui</a></li>
                    </ul>
                </el-alert>
                <div class="responsive-table">
                    <table class="table-confirmation">
                        <thead>
                        <tr>
                            <th>Minicurso</th>
                            <th>Valor</th>
                            <th>Data</th>
                            <th align="center">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in dependencies.minicursos">
                            <td>{{item.title}}</td>
                            <td>R$ {{getMinicursoAmount(item) | currencyEnToBr}}</td>
                            <td>{{item.start_datetime | dateTimeEnToBr}}</td>
                            <td align="center">
                                <el-button size="small"
                                           type="success"
                                           @click="onMinicursoRegistration(item)"
                                           v-if="!item.registration && item.open_registration && registrationNotCharged">
                                    <i class="fa fa-plus"></i>
                                    <span>Inscrever-se</span>
                                </el-button>
                                <template
                                        v-if="item.registration && item.registration.status && item.registration.status.key !== 'cancelado'">
                                    <el-tag size="medium">Inscrito</el-tag>
                                    <el-button size="small"
                                               @click="onCancelMinicursoRegistration(item)"
                                               type="danger">
                                        <i class="fa fa-time"></i>
                                        <span>Cancelar Participação</span>
                                    </el-button>
                                </template>
                                <router-link :to="{name: 'presence.show', params: {id: item.id}}"
                                             v-if="hasSupportCommitteeModality"
                                             class="el-button el-button--info el-button--small">
                                        <span class="sidebar-icon">
                                            <i class="fa fa-check-circle-o"></i>
                                        </span>
                                    <span class="text">Presenças</span>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog title="Editar Instituição"
                   width="94%"
                   :visible.sync="modalEditInstitutionVisible">
            <el-form ref="formInstitution"
                     label-position="top">
                <el-form-item label="Instituição"
                              class="is-required"
                              :class="{ 'el-form-item--error': $v.institution_unit_id.$error }">
                    <el-select v-model="institution_unit_id"
                               clearable
                               filterable
                               remote
                               :remote-method="onSearchInstitution"
                               :loading="isSearchingInstitution"
                               placeholder="Digite o nome da instituição"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.institution_unit_id.$touch()">
                        <el-option
                                v-for="item in dependencies.institutions"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.institution_unit_id.$error"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveInstitution"
                           :disabled="$v.institution_unit_id.$invalid">
                    Salvar Instituição
                </el-button>
                <el-button @click="onHandleModalEditInstitution">Fechar</el-button>
            </div>
        </el-dialog>
        <el-dialog title="Editar Escolaridade"
                   width="94%"
                   :visible.sync="modalEditLiteracyVisible">
            <el-form ref="formLiteracy"
                     label-position="top">
                <el-form-item label="Escolaridade"
                              class="is-required"
                              :class="{ 'el-form-item--error': $v.literacy_id.$error }">
                    <el-select v-model="literacy_id"
                               clearable
                               filterable
                               placeholder="Selecione uma Escolaridade"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.literacy_id.$touch()">
                        <el-option
                                v-for="item in dependencies.literacies"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.literacy_id.$error"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveLiteracy"
                           :disabled="$v.literacy_id.$invalid">
                    Salvar Escolaridade
                </el-button>
                <el-button @click="onHandleModalEditLiteracy">Fechar</el-button>
            </div>
        </el-dialog>
        <el-dialog title="Editar Áreas do Conhecimento"
                   width="94%"
                   :visible.sync="modalEditKnowledgeAreaVisible">
            <el-form ref="formKnowledgeArea"
                     label-position="top">
                <el-alert
                        title="Como avaliador você pode informar as áreas de conhecimento que se considera apto a avaliar."
                        class="submission-tips"
                        type="warning"
                        :closable="false">
                </el-alert>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Grande Área">
                            <el-select v-model="knowledge_area.knowledge_area_1_id"
                                       filterable
                                       clearable
                                       multiple
                                       placeholder="Selecione uma opção"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @change="changeKnowledgeArea(knowledge_area.knowledge_area_1_id, 2)"
                                       @remove-tag="removeKnowledgeArea">
                                <el-option
                                        v-for="item in dependencies.knowledge_areas_level_1"
                                        :key="item.id"
                                        :label="'(' + item.cnpq_code + ') ' + item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Área">
                            <el-select v-model="knowledge_area.knowledge_area_2_id"
                                       :disabled="!knowledge_area.knowledge_area_1_id.length"
                                       filterable
                                       clearable
                                       multiple
                                       placeholder="Selecione uma opção"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @change="changeKnowledgeArea(knowledge_area.knowledge_area_2_id, 3)"
                                       @remove-tag="removeKnowledgeArea">
                                <el-option
                                        v-for="item in dependencies.knowledge_areas_level_2"
                                        :key="item.id"
                                        :label="'(' + item.cnpq_code + ') ' + item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Sub-área">
                            <el-select v-model="knowledge_area.knowledge_area_3_id"
                                       :disabled="!knowledge_area.knowledge_area_2_id.length"
                                       filterable
                                       clearable
                                       multiple
                                       placeholder="Selecione uma opção"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @change="changeKnowledgeArea(knowledge_area.knowledge_area_3_id, 4)"
                                       @remove-tag="removeKnowledgeArea">
                                <el-option
                                        v-for="item in dependencies.knowledge_areas_level_3"
                                        :key="item.id"
                                        :label="'(' + item.cnpq_code + ') ' + item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Especialidade">
                            <el-select v-model="knowledge_area.knowledge_area_4_id"
                                       :disabled="!knowledge_area.knowledge_area_3_id.length"
                                       filterable
                                       clearable
                                       multiple
                                       placeholder="Selecione uma opção"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full"
                                       @change="changeKnowledgeArea(knowledge_area.knowledge_area_4_id, 5)"
                                       @remove-tag="removeKnowledgeArea">
                                <el-option
                                        v-for="item in dependencies.knowledge_areas_level_4"
                                        :key="item.id"
                                        :label="'(' + item.cnpq_code + ') ' + item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveKnowledgeAreas">
                    Salvar Áreas do Conhecimento
                </el-button>
                <el-button @click="onHandleModalEditKnowledgeArea">Fechar</el-button>
            </div>
        </el-dialog>
        <el-dialog title="Boleto"
                   :visible.sync="modalInvoice"
                   top="2vh"
                   width="90vw">
            <div class="modal-pdf">
                <object :data="invoiceUrl"
                        type="application/pdf">
                    <embed :src="invoiceUrl"
                           type="application/pdf"/>
                </object>
            </div>
            <div slot="footer" class="dialog-footer">
                <a class="el-button el-button--primary"
                   :href="invoiceUrl + '/download'" target="_blank">Baixar Boleto</a>
            </div>
        </el-dialog>
        <el-dialog title="Certificado"
                   :visible.sync="certificate.modal"
                   top="2vh"
                   width="90vw">
            <div class="modal-pdf">
                <object :data="certificate.path"
                        type="application/pdf">
                    <embed :src="certificate.path"
                           type="application/pdf"/>
                </object>
            </div>
            <div slot="footer" class="dialog-footer">
                <a class="el-button el-button--primary"
                   :href="certificate.path_download" target="_blank">Baixar Certificado</a>
            </div>
        </el-dialog>
        <el-dialog title="Questionário Congrega 2018"
                   :visible.sync="modalLimesurvey"
                   width="20vw">
            <div style="text-align: center;">
                <a class="el-button el-button--primary el-button--large"
                   :href="linkLimesurvey"
                   target="_blank">
                    <i class="fa fa-list-ul"></i>
                    <span>Responder Questionário</span>
                </a>
            </div>
            <div slot="footer" class="dialog-footer">
                <a class="el-button" @click="modalLimesurvey = !modalLimesurvey">Fechar</a>
            </div>
        </el-dialog>
        <el-dialog
          title="Pagamento On-line"
          :visible.sync="modalOnlinePaymentLinkVisible">
          <span>
            O pedido nº <strong>{{onlinePaymentOrder}}</strong> no valor de
            <strong>R$ {{onlinePaymentValue | currencyEnToBr}}</strong> foi gerado com sucesso.
            Caso não tenha aberto uma
            janela no seu navegador, clique no link abaixo para efetuar o pagamento.
          </span>
          <span>
              <strong>
                <a :href="onlinePaymentUrl" target="_blank">{{onlinePaymentUrl}}</a>
              </strong>
          </span>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="modalOnlinePaymentLinkVisible = false">Ok, entendi!</el-button>
          </div>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>

    .tab-slot {
        position: relative;
        padding-right: 5px;

        .fa {
            margin-right: 5px;
        }

        .payment-bullet {
            position: absolute;
            right: -10px;
            top: 15px;
            display: inline-block;
            width: 10px;
            height: 10px;
            background-color: #00a65a;
            border-radius: 50%;

            &.-not-settled {
                background-color: #be2626;
            }
        }
    }

    .certificates-buttons {
        .el-button {
            margin: 2px 0;
        }
    }

    .certificate-not-available {
        color: #808080;
    }

    .invoice-info {
        text-align: center;
    }

    .btn-edit-registration {
        padding: 4px 8px;
        margin-right: 5px;
    }

    .payment-settled {
        padding: 0 25px !important;
        font-size: 18px;
        height: auto !important;
        line-height: 42px !important;
    }

    .paper-certificate {
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0;
        display: flex;
        align-items: center;

        &:last-child {
            border-bottom: none;
        }
    }

    @media all and (max-width: 768px) {
        .registration-data {
            > .el-col-12 {
                width: 100%;
            }
        }
        .invoice-info .barcode-icon .fa {
            font-size: 80px;
        }
    }
</style>
